import { Types } from "@grandvisionhq/graphql";
import { getPaymentImplementation } from "@grandvisionhq/payments";
const mapPaymentDetailsForOrder = ({
  paymentDetails,
  selectedPaymentMethod,
  intl,
  cartId,
  totalPrice,
  returnUrl
}) => {
  const paymentDraft = {
    paymentMethod: selectedPaymentMethod.type,
    paymentServiceProvider: Types.PSP[selectedPaymentMethod.provider],
    paymentDetails: paymentDetails ? paymentDetails.data : {},
    amount: {
      currency: intl.currency,
      value: totalPrice,
      fractionDigits: 2
    },
    returnUrl: returnUrl || ""
  };
  const paymentImplementation = getPaymentImplementation(
    selectedPaymentMethod.provider,
    selectedPaymentMethod.type
  );
  if (!paymentImplementation) {
    throw new Error(
      `Don't have implementation for '${selectedPaymentMethod.type}', provider: '${selectedPaymentMethod.provider}'`
    );
  }
  return {
    checkoutId: cartId,
    paymentRequest: paymentDraft
  };
};
export {
  mapPaymentDetailsForOrder
};
//# sourceMappingURL=payment-details-mapper.js.map
